<template>
    <div>
        <div
            class="kgr-region kgr-region--lightGray kgr-region--rounded kgr-row kgr-row--bigMargin"
        >
            <h2
                v-t="'Hund hinzufügen'"
                class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText"
            ></h2>
            <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--center">
                <div
                    class="kgr-postfix__fixed"
                    :class="{ 'error-state': error.forField('relationDog') }"
                >
                    <kgr-club-dog-select
                        ref="dogSelect"
                        v-model="relation.dog"
                        :club-id="clubId"
                        :excluded-ids="associatedDogIds"
                    />
                </div>

                <div
                    class="kgr-postfix__fixed"
                    :class="{ 'error-state': error.forField('relationAssociation') }"
                >
                    <div class="kgr-inputGroup__label">
                        {{ $t('Zugehörigkeit') }}
                    </div>
                    <kgr-generic-select
                        v-model="relation.association"
                        :options="associationOptions"
                        display="label"
                        :error="error.messageForField('relationAssociation')"
                    />
                </div>

                <div class="kgr-postfix__fixed">
                    <kgr-button
                        :value="$t('add')"
                        :pending="pendingCreate"
                        :disabled="isDisabled"
                        class="dogRelationAddButton"
                        @click="addRelation()"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClubDogSelect from '../common/form/select/ClubDogSelect.vue';
import Error from '../../js/model/Error.js';
import GenericSelect from '../common/form/select/GenericSelect.vue';
import KgrButton from '../common/form/button/KgrButton.vue';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-club-dog-select': ClubDogSelect,
        'kgr-generic-select': GenericSelect,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        relations: {
            type: Array,
            required: true,
            default: () => {
                return [];
            },
        },
        error: {
            type: Error,
            required: true,
        },
        isCreatable: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            associationOptions: [
                { label: this.$t('club.dog.memberRelation.association.owner'), value: 'owner' },
                { label: this.$t('club.dog.memberRelation.association.handler'), value: 'handler' },
            ],
            relation: {},
            pendingCreate: false,
        };
    },
    computed: {
        associatedDogIds() {
            return this.relations.map((relation) => relation.dog.id);
        },
        isDisabled() {
            return this.relation.dog === undefined || this.relation.association === undefined;
        },
    },
    created() {
    },
    methods: {
        addRelation() {
            this.$emit('addRelation', this.relation);
            this.$refs.dogSelect.resetSelected();
            this.relation = {};
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .dogRelationAddButton {
    margin-top: 18px;
}
.error-state {
    border-color: #f44336;
}
</style>
